import PageContainerBlank from '../components/PageContainer/PageContainerBlank';
import PageEndBlank from '../components/PageContainer/PageEndBlank';

const Prayer = () => {
	return (
		<div>
			<PageContainerBlank />

			<h1>Prayer Tools</h1>
			<p className="justify"><span className="tab"></span>There are many different chaplets and devotions to draw you near to Christ. This website offers multiple Prayer subpages, each for its own devotion. Every prayer page contains a guide as well as meditation companions in the form of holy art.</p>

			<br />
			<img src="/static/images/prayer/PrayerObjects.webp" alt="Prayer Objects" className="img-divider" />
			<br />
			<br />

			<p className="centered">
				The National Holy Name site offers even more prayers:<br />
				<a href="https://www.nahns.org/jesusprayers" target="_blank" rel="noreferrer">https://www.nahns.org/jesusprayers</a>
			</p>
			<br />

			<h2>The Divine Praises</h2>
			<p className="pledge-text">
				Blessed be God.<br />
				Blessed be His Holy Name.<br />
				Blessed be Jesus Christ, true God and true Man.<br />
				Blessed be the Name of Jesus.<br />
				Blessed be His Most Sacred Heart.<br />
				Blessed be His Most Precious Blood.<br />
				Blessed be Jesus in the Most Holy Sacrament of the Altar.<br />
				Blessed be the Holy Spirit, the Paraclete.<br />
				Blessed be the great Mother of God, Mary most Holy.<br />
				Blessed be her Holy and Immaculate Conception.<br />
				Blessed be her Glorious Assumption.<br />
				Blessed be the name of Mary, Virgin and Mother.<br />
				Blessed be St. Joseph, her most chaste spouse.<br />
				Blessed be God in His Angels and in His Saints.<br />
			</p>

			<PageEndBlank />
		</div>
	);
};

export default Prayer;